/* import __COLOCATED_TEMPLATE__ from './impersonated-user-search-opener.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent-2 */
import type UserSummary from 'embercom/objects/inbox/user-summary';
import Component from '@glimmer/component';
import safeWindowOpen from 'embercom/lib/safe-window-open';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type Session from 'embercom/services/session';

interface ImpersonatedUserSearchOpenerArgs {
  user?: UserSummary | null;
  onClick: () => void;
}

interface Signature {
  Args: ImpersonatedUserSearchOpenerArgs;
  Element: HTMLElement;
}

export default class ImpersonatedUserSearchOpener extends Component<Signature> {
  @service declare router: RouterService;
  @service declare session: Session;
  @service declare appService: $TSFixMe;

  @action openUserProfile() {
    if (!this.args.user) {
      return;
    }
    let url = this.router.urlFor(
      'apps.app.users.user',
      this.session.workspace.id,
      this.args.user.id,
    );
    safeWindowOpen(url, '_blank');
  }

  get isFinStandaloneApp() {
    return this.appService.app.isStandaloneApp;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'AiAgent::Impersonation::ImpersonatedUserSearchOpener': typeof ImpersonatedUserSearchOpener;
  }
}
